<div class="header">
  @if (hasActive()) {
    <svg class="header-spinner" viewBox="0 0 20 20" fill="none" aria-hidden="true">
      <line x1="10" y1="2" x2="10" y2="6" />
      <line x1="10" y1="14" x2="10" y2="18" />
      <line x1="2" y1="10" x2="6" y2="10" />
      <line x1="14" y1="10" x2="18" y2="10" />
      <line x1="4.34" y1="4.34" x2="7.17" y2="7.17" />
      <line x1="12.83" y1="12.83" x2="15.66" y2="15.66" />
      <line x1="15.66" y1="4.34" x2="12.83" y2="7.17" />
      <line x1="7.17" y1="12.83" x2="4.34" y2="15.66" />
    </svg>
  }
  <span class="title">Tasks</span>
</div>
<ol class="tasks">
  @for (task of tasks(); track $index) {
    <li class="task" [class]="task.status">
      <span class="task-icon" role="img" [attr.aria-label]="statusLabels[task.status]">
        @if (task.status === 'completed') {
          <ng-icon name="tablerCircleCheckFill" size="18px" />
        } @else {
          <loader size="18px" />
        }
      </span>
      <div class="task-body">
        <span class="task-title">{{ task.title }}</span>
        @if (task.description) {
          <span class="task-description">{{ task.description }}</span>
        }
      </div>
    </li>
  }
</ol>
